<template>
  <b-form-group
    :label="label"
    :label-for="labelFor"
    :class="customClass"
    class="text-left"
  >
    <slot></slot>
    <b-form-invalid-feedback v-if="invalidFeedback" :id="feedbackId">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: "BaseFormGroup",
  props: {
    label: {
      type: String,
      required: true,
    },
    labelFor: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      default: "",
    },
    invalidFeedback: {
      type: String,
      default: "",
    },
    feedbackId: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
/* Add any custom styling here if needed */
</style>
